import * as React from 'react';
import { Dialog, DialogTitle, DialogActions, Button } from '@mui/material';

export interface IDeleteConfirmation {
  title: string;
  content?: string;
  open: boolean;
  onDelete: () => void;
  close: () => void;
}

const DeleteConfirmation = (props: IDeleteConfirmation) => {
  return (
    <Dialog onClose={props.close} open={props.open}>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogActions>
        <Button variant="text" onClick={props.close}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={props.onDelete}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmation;
